
import { Observers } from "./observers";
import { ArticleModel, ArticleModelObserver, BackgroundAnimation, LottieSettings, Domrefs } from "./types"

export class Model implements ArticleModel {
	observers;
	currentVisibleTextbox;
	currentAikajanaText;
	howmuchScrolled;
	progressVisibleTextbox;
	hiddenSvgElements = [];
	currentBackground
	currentBackgroundAnimationSettings;
	oldBackgroundAnimationSettings = [];
	currentLottieAnimationFileName;
	specialEffect
	specialEffectType
	resetSpecialEffect: () => void = () => null;
	backgroundAnimationId:string;
	isDesktop = false;

	constructor(observers: ArticleModelObserver) {
		console.log("run")
		this.observers = observers;
	}


	changeVisibleTextbox(textbox: HTMLElement): void {
		this.currentVisibleTextbox = textbox;
		this.observers.onVisibleTextboxChange(textbox, this);
	}

	changeAikajanaText(text: string): void {
		this.currentAikajanaText = text;
		this.observers.onAikajanaChange(text);
	}


	changeHowMuchRead(pageYOffset: number) {
		this.howmuchScrolled = pageYOffset
		this.observers.onHowMuchReadChange(pageYOffset);
	}

	changeProgressOfVisibleTextbox(value: number): void {
		this.progressVisibleTextbox = value;
		this.observers.onProgressOfVisibleTextbox(value, this)
	}

	changeBackground(value: string): void {

		if (!value) return;
		if (value === this.currentBackground) return
		this.observers.onBackgroundChange(value, this.currentBackground)

		this.currentBackground = value;
	}
	changeHiddenSvgElements(backgroundName: string, elements: string[]): void {
		const oldHiddenSvgElements = this.hiddenSvgElements
		this.observers.onHiddenElementsChange(backgroundName, oldHiddenSvgElements, elements)
		this.hiddenSvgElements = elements;
	}

	changeBackgroundAnimation(settings: BackgroundAnimation, scrollProgress?: number, caller?: string): void {
		if(settings.id) {
			this.backgroundAnimationId = settings.id;
		}
		this.observers.onBackgroundAnimationChange(this.currentBackground, settings, this.currentBackgroundAnimationSettings, this, scrollProgress)
		this.currentBackgroundAnimationSettings = settings;
	}

	changeLottieAnimation(settings: LottieSettings) {
		this.currentLottieAnimationFileName = settings.tiedostoNimi;
		this.observers.onLottieAnimationChange(settings)

	}

	resetLottieAnimation() {
		this.currentLottieAnimationFileName = ""
	}

	changeSpecialEffect(id: string, type: string | undefined) {
		this.specialEffect = id;
		this.specialEffectType = type;

		const storeSpecialEffectResetFunction = (cb) => {
			// FIXME: THIS IS NOT NEEDED / OVERLY COMPLICATED
			this.resetSpecialEffect = () => {
				cb()
			}
		}
		this.observers.onSpecialEffectChange(this, storeSpecialEffectResetFunction);

	}
}